import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DeviceType } from '@umss/shared/data-access';
import { HttpHelper } from '@umss/shared/utils';
import { API_BASE_URL } from '../tokens/api-base-url.token';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = inject(API_BASE_URL);

  // Check apiUrl is defined
  try {
    new URL(apiUrl);
  } catch {
    throw new Error(
      `Invalid API_URL: The API URL provided ${apiUrl} is not a valid URL.`
    );
  }

  // Don't set Content-Type for FormData requests (file uploads)
  // The browser will automatically set the correct multipart/form-data with boundary
  const headers: Record<string, string> = {
    'X-Device-Type': DeviceType.WEB
  };

  // Only set Content-Type to application/json if body is not FormData
  if (!(req.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  // In local development (apiUrl = localhost), keep /api URLs relative so the Angular proxy
  // handles routing. This allows the app to work via ngrok or external IP on mobile devices.
  // In all other environments (dev/staging/prod), rewrite to the absolute API URL as usual.
  const isLocalDev =
    apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1');
  const keepRelative = isLocalDev && req.url.startsWith('/api');
  const finalUrl = keepRelative
    ? req.url
    : HttpHelper.prepareUrl(req.url, apiUrl);

  const updatedReq = HttpHelper.addMissingHeaders(
    req.clone({
      url: finalUrl
    }),
    headers
  );
  return next(updatedReq);
};
